import i18n from "../../../i18n"

export const professors =
{
    department: i18n.t("eco_department"),
    professors:

        [
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'katerina',
                lname: 'kyrtsou',
                title: 'proedrosTmimatos',
                tel: '2310 891.764',
                email: 'ckyrtsou@uom.edu.gr',
                building: 'ΓΔ5',
                office: '504'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1827/1228-varelas-2.jpg',
                fname: 'erotokritos',
                lname: 'varelas',
                title: 'kathigitis',
                tel: '2310 891.761',
                email: 'varelas@uom.edu.gr',
                building: 'ΓΔ2',
                office: '208'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'konstantinos',
                lname: 'velentzas',
                title: 'kathigitis',
                tel: '2310 891.783',
                email: 'vele@uom.edu.gr',
                building: 'ΓΔ4',
                office: '406'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1830/4311-Ioannidis-2.png',
                fname: 'dimitrios',
                lname: 'ioannidis',
                title: 'kathigitis',
                tel: '2310 891.785',
                email: 'dimioan@uom.edu.gr',
                building: 'ΓΔ4',
                office: '408'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1844/11999-KaragiannisGiannis-2.jpg',
                fname: 'giannis',
                lname: 'karagiannis',
                title: 'kathigitis',
                tel: '2310 891.759',
                email: 'karagian@uom.edu.gr',
                building: 'ΓΔ4',
                office: '502'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'konstantinos',
                lname: 'karfakis',
                title: 'kathigitis',
                tel: '2310 891.710',
                email: 'ckarf@uom.edu.gr',
                building: 'ΓΔ',
                office: '411'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'christos',
                lname: 'constantatos',
                title: 'kathigitis',
                tel: '2310 891.725',
                email: 'cconst@uom.edu.gr',
                building: 'ΓΔ3',
                office: '503'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1831/1679-katranid-2.jpg',
                fname: 'stelios',
                lname: 'katranidis',
                title: 'kathigitis',
                tel: '2310 891.772',
                email: 'katranid@uom.edu.gr',
                building: 'ΓΔ3',
                office: '307'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'ioannis',
                lname: 'mourmouras',
                title: 'kathigitis',
                tel: '2310 891.777',
                email: 'iam@uom.edu.gr',
                building: 'ΓΔ4',
                office: '407'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'agelike',
                lname: 'nikolaou',
                title: 'kathigitria',
                tel: '2310 891.776',
                email: 'agelike@uom.edu.gr',
                building: 'ΓΔ3',
                office: '312'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1836/6866-teconomides-2.jpg',
                fname: 'anastasios',
                lname: 'economides',
                title: 'kathigitis',
                tel: '2310 891.799',
                email: 'economid@uom.edu.gr',
                building: 'ΓΔ5',
                office: '508'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1849/1560-ThPanagiotidis_ed-2.jpg',
                fname: 'theodore',
                lname: 'panagiotidis',
                title: 'kathigitis',
                tel: '2310 891.736',
                email: 'tpanag@uom.edu.gr',
                building: 'ΓΔ',
                office: '306'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1840/1977-Sartzetakis_edited-2.jpg',
                fname: 'eftihios',
                lname: 'sartzetakis',
                title: 'kathigitis',
                tel: '2310 891.680',
                email: 'esartz@uom.edu.gr',
                building: 'ΓΔ',
                office: '206'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'lefteris',
                lname: 'tsoulfidis',
                title: 'kathigitis',
                tel: '2310 891.788',
                email: 'agelike@uom.edu.gr',
                building: 'ΓΔ4',
                office: '412'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/1843/1212-sfountas-2.jpg',
                fname: 'stylianos',
                lname: 'fountas',
                title: 'kathigitis',
                tel: '2310 891.774',
                email: 'sfountas@uom.edu.gr',
                building: 'ΓΔ',
                office: '507'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'theologos',
                lname: 'pantelidis',
                title: 'anaplirotisKathigitis',
                tel: '2310 891.726',
                email: 'pantelidis@uom.edu.gr',
                building: 'ΓΔ',
                office: '410'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'maria',
                lname: 'alipranti',
                title: 'epikouriKathigitria',
                tel: '2310 891.755',
                email: 'alipranti@uom.edu.gr',
                building: 'ΓΔ',
                office: '308'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/8623/8100-PHOTO-2.png',
                fname: 'katerina',
                lname: 'litina',
                title: 'epikouriKathigitria',
                tel: '2310 891.663',
                email: 'anastasia.litina@uom.edu.gr',
                building: 'ΓΔ',
                office: '212'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/4319/1578-boikosSpiridon-2.jpg',
                fname: 'spyridon',
                lname: 'boikos',
                title: 'epikourosKathigitis',
                tel: '2310 891.779',
                email: 'boikos@uom.edu.gr',
                building: 'ΓΔ',
                office: '207'
            },
            {
                imgUrl: 'https://www.uom.gr/assets/site/public/nodes/3667/4448-Filippiadis-2.jpg',
                fname: 'eleftherios',
                lname: 'filippiadis',
                title: 'epikourosKathigitis',
                tel: '2310 891.770',
                email: 'efilipp@uom.edu.gr',
                building: 'ΓΔ',
                office: '310'
            },
            {
                imgUrl: 'https://www.uom.gr/site/images/personphoto-2.jpg',
                fname: 'revekka',
                lname: 'christopoulou',
                title: 'epikouriKathigitria',
                tel: '2310 891.825',
                email: 'christopoulou@uom.edu.gr',
                building: 'ΓΔ',
                office: '311'
            }
        ]
}